module.exports = __webpack_public_path__ + "static/media/light-theme-idling-alt.8fe04f64.svg";